/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ocultarAcoes } from "../../../services/acesso";
import api from "../../../services/api";
import { Tooltip, Typography } from "@mui/material";
import { useEffect, useState, useMemo, useCallback } from "react";
import asaasLogo from "../../../assets/asaas.png";
import { FiTruck, FiUser } from "react-icons/fi";
import ModalAlerta from "../../../components/modal";
import { useAppSelector } from "../../../store/hooks";
import ModalForm from "../../../components/modal-form";
import { TipoFormulario } from "../../../services/constantes";
import { FaCheck, FaCheckDouble, FaEdit, FaFileAlt, FaFilePdf, FaLink, FaMoneyBill, FaQrcode, FaTrash, FaFileInvoiceDollar, FaFileInvoice, FaLayerGroup, FaFlag } from "react-icons/fa";
import ModalParcelamento from "../../../components/modal-parcelamento";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import ListagemPagamento, { Totalizadores } from "../../../components/listagem-pagamentos";
import ModalConfirmacaoPagamento from "../../../components/modal-confirmacao-pagamento";
import { FaCarSide, FaMotorcycle, FaTimesCircle, FaWhatsapp } from 'react-icons/fa';
import { obterIdTenent, obterNomeEmpresa, usuarioTemPermissao } from "../../../services/seguranca";
import { useFiliais } from "../../../hooks/useFiliais";
import { converterStatusPagamentoParaTexto, formatDate, formatarParaReais, getWeekRange, parseDateFromString, dateToInputValue } from "../../../services/utilitarios";
import { ApiError, Banco, Campo, ConfiguracaoEmpresa, Locacao, Opcao, Pagamento, StatusPagamento, TipoPeriodicidadePagamento } from "../../../services/tipos";
import { useLocation } from "react-router-dom";
import { ReciboPagamento } from "../../../components/recibo/recibo-pagamento";
import { agruparRecibosPorCliente, gerarPdfRecibos, gerarPdfRecibosUnificados, locacaoCompletaParaRecibo } from "../../../components/recibo/recibo-pagamento-pdf";
import { LIMITE_DOCUMENTOS_EM_LOTE, PixFatura, comPixUnico, faturaDePagamento, idsDistintos, pagamentoEmAberto, pagamentosComRecibo, unificarPorCliente, valorEmAbertoDaFatura } from "../../../components/fatura/fatura-dados";
import { gerarPdfFaturas } from "../../../components/fatura/fatura-pdf";
import { carregarEmpresaDoToken, carregarLocacoesPorId, carregarPixDosPagamentos, carregarPixPorValor, carregarValoresDeCobranca } from "../../../components/fatura/documentos-lote";
import { abrirPdfNoVisualizador, carregarLogoDaEmpresa } from "../../../components/pdf/abrir-pdf";
import { confirm } from "../../../components/confirm";
import { OPCOES_PRAZO_TODAS, OpcaoComMaximo } from "../../../components/select-number";
import { NFServiceService } from "../../../services/NFServiceService";
import ModalEmitirNota from "../notas-fiscais/ModalEmitirNota";

import { ModalConfirmacaoLote } from "../../../components/modal-confirmacao-lote";
import { ModalAjusteValorLote } from "../../../components/modal-ajuste-valor-lote";

function PagamentoListagem() {
    const { empresaTemFiliais, filiaisOptions, labelComFilial } = useFiliais();
    const [dataInicial, setDataInicial] = useState("");
    const [chavePix, setChavePix] = useState<string>("");
    const [motivoPagamento] = useState<string>('ALUGUEL');
    const [pagamentos, setPagamentos] = useState<Pagamento[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [veiculosOptions, setVeiculosOptions] = useState<Opcao[]>([]);
    const [geraPagamentoUnico, setGeraPagamentoUnico] = useState(false);
    const [showModalSimNao, setShowModalSimNao] = useState<boolean>(false);
    const [locatariosOptions, setLocatariosOptions] = useState<Opcao[]>([]);
    const [pagamentoSelecionado, setPagamentoSelecionado] = useState<any>({});
    const [messageModalSimNao, setMessageModalSiMNao] = useState<string[]>([]);
    const [isSavingPagamentos, setIsSavingPagamentos] = useState<boolean>(false);
    const [exibirFormModalPagamentos, setExibirFormModalPagamentos] = useState(false);
    const [locacaoSelecionado, setLocacaoSelecionado] = useState<Locacao>({} as Locacao);
    const [mensagemCobrancaWhatsApp, setMensagemCobrancaWhatsApp] = useState<string>("");
    const [showModalConfirmarExclusao, setShowModalConfirmarExclusao] = useState<boolean>(false);
    const [entidadeParaAtualizarPagamentos, setEntidadeParaAtualizarPagamentos] = useState<any>({});
    const [messageModalConfirmarExclusao, setMessageModalConfirmarExclusao] = useState<string[]>([]);
    const [showModalConfirmacaoPagamento, setShowModalConfirmacaoPagamento] = useState<boolean>(false);
    const [showModalParcelamento, setShowModalParcelamento] = useState<boolean>(false);
    const [valorInicialModalConfirmacaoPagamento, setValorInicialModalConfirmacaoPagamento] = useState<number>(0);
    const [forcarAtualizacaoDeEntidadeNoModalPagamentos, setForcarAtualizacaoDeEntidadeNoModalPagamentos] = useState<boolean>(false);
    const [filtroInicialAplicado, setFiltroInicialAplicado] = useState(false);
    const [isMobile] = useState(window.innerWidth <= 768);
    const [triggerBuscar, setTriggerBuscar] = useState<boolean>(true);
    const [triggerRecibo, setTriggerRecibo] = useState<number>(0);
    const [pagamentoParaRecibo, setPagamentoParaRecibo] = useState<Pagamento | null>(null);
    const [opcoesPrazoMinimo, setOpcoesPrazoMinimo] = useState<OpcaoComMaximo[]>(OPCOES_PRAZO_TODAS);
    const [carregandoResumo, setCarregandoResumo] = useState<boolean>(false);
    const [showModalNovo, setShowModalNovo] = useState(false);
    const [isSavingNovo, setIsSavingNovo] = useState(false);
    const [forcarAtualizacaoNovoPagamento, setForcarAtualizacaoNovoPagamento] = useState(false);

    // Estados para emissão de NFSe
    const [showModalEmitirNota, setShowModalEmitirNota] = useState(false);
    const [dadosParaEmitirNota, setDadosParaEmitirNota] = useState<any>(null);
    const [configuracao, setConfiguracao] = useState<ConfiguracaoEmpresa | null>(null);
    const [emissaoLiberada, setEmissaoLiberada] = useState<boolean>(false);
    const [contaIntegradaAsaas, setContaIntegradaAsaas] = useState<boolean>(false);

    useEffect(() => {
        if (token) {
            fetchConfiguracao();
        }
    }, [token]);

    useEffect(() => {
        if (!token) return;
        api.get('ConfiguracaoFilial/ResolvidaAtual')
            .then(r => setContaIntegradaAsaas(!!r.data?.asaasConfigurado))
            .catch(() => setContaIntegradaAsaas(false));
    }, [token]);

    // Estados para Ações em Lote
    const [showModalLote, setShowModalLote] = useState(false);
    const [showModalEditarValor, setShowModalEditarValor] = useState(false);
    const [dadosEditarValor, setDadosEditarValor] = useState<any[]>([]);
    const [itensEditarValor, setItensEditarValor] = useState<any[]>([]);
    const [carregandoEditarValor, setCarregandoEditarValor] = useState(false);
    // Filtros resolvidos (já com locação/locatário/veículo roteados) usados na chamada do ajuste em lote.
    const [filtrosEditarValor, setFiltrosEditarValor] = useState<any>(null);
    const [dadosLote, setDadosLote] = useState<any[]>([]);
    const [acaoLote, setAcaoLote] = useState<'baixar' | 'cancelar'>('baixar');

    // Novo estado para armazenar os totais vindos do backend
    const [totalizadoresBackend, setTotalizadoresBackend] = useState<Totalizadores>({
        pagos: { valor: 0, quantidade: 0 },
        aVencer: { valor: 0, quantidade: 0 },
        emAtraso: { valor: 0, quantidade: 0 },
        locatarios: 0
    });

    const [locacoesOptions, setLocacoesOptions] = useState<any[]>([]);
    // Opcoes de busca combinadas (Locacao + Locatario + Veiculo). O value e prefixado para o handleBuscar rotear.
    const [opcoesBuscaPagamento, setOpcoesBuscaPagamento] = useState<any[]>([]);
    const [bancos, setBancos] = useState<Banco[]>([]);

    const temPermissao = usuarioTemPermissao(token, 'pagamento_visualizar');
    const temPermissaoCriar = usuarioTemPermissao(token, 'pagamento_novo');
    const podeVerNota = usuarioTemPermissao(token, 'nfse_visualizar');
    const podeEmitirNota = usuarioTemPermissao(token, 'nfse_emitir');

    const location = useLocation();

    const [filtrosAtuais, setFiltrosAtuais] = useState({
        dataInicio: null as Date | null,
        dataFim: null as Date | null,
        status: StatusPagamento.Todos,
        buscarPendentes: false,
        idLocacao: "",
        idLocatario: "",
        idVeiculo: "",
        id: "",
        tipoPeriodo: "vencimento" as "vencimento" | "pagamento",
        statusLocacao: "todas" as "todas" | "ativas" | "encerradas"
    });

    const [filtrosAplicados, setFiltrosAplicados] = useState({
        dataInicio: null as Date | null,
        dataFim: null as Date | null,
        status: StatusPagamento.Todos,
        buscarPendentes: false,
        idLocacao: "",
        idLocatario: "",
        idVeiculo: "",
        id: "",
        tipoPeriodo: "vencimento" as "vencimento" | "pagamento",
        statusLocacao: "todas" as "todas" | "ativas" | "encerradas"
    });

    const [tipoPeriodoAtual, setTipoPeriodoAtual] = useState<"vencimento" | "pagamento">("vencimento");
    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
    });

    const fetchLocacoes = async () => {
        try {
            const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
            const novasOpcoes = response.data.map((locacao: any) => ({
                value: locacao.id,
                label: labelComFilial(`${locacao.locatario.nome} - ${locacao.veiculo.placa}`, locacao.idFilial),
            }));
            setLocacoesOptions(novasOpcoes);

            // Opcoes combinadas para a busca: Locacao, Locatario e Veiculo (value prefixado).
            const opcoesLocacao = response.data.map((locacao: any) => ({
                value: `loc:${locacao.id}`,
                label: labelComFilial(`🔗 ${locacao.locatario.nome} - ${locacao.veiculo.placa}`, locacao.idFilial),
            }));
            setOpcoesBuscaPagamento(opcoesLocacao);

            try {
                const [respLocatarios, respVeiculos] = await Promise.all([
                    api.get(`/LocatariosPorEmpresa/${obterIdTenent(token)}`),
                    api.get(`/VeiculoPorEmpresa/${obterIdTenent(token)}`),
                ]);
                const opcoesLocatario = (respLocatarios.data || []).map((l: any) => ({
                    value: `lct:${l.id}`,
                    label: labelComFilial(`👤 ${l.nome}${l.documento ? ` (${l.documento})` : ''}`, l.idFilial),
                }));
                const opcoesVeiculo = (respVeiculos.data || []).map((v: any) => ({
                    value: `vei:${v.id}`,
                    label: labelComFilial(`🚗 ${v.placa} - ${v.marca} ${v.modelo}`, v.idFilial),
                }));
                setOpcoesBuscaPagamento([...opcoesLocacao, ...opcoesLocatario, ...opcoesVeiculo]);
            } catch (err) {
                // Mantem ao menos as locacoes se locatarios/veiculos falharem.
                console.error("Erro ao carregar locatários/veículos para busca", err);
            }
        } catch (error) {
            console.error("Erro ao carregar locações para filtro", error);
        }
    }

    useEffect(() => {
        if (token) {
            fetchLocacoes();
        }
    }, [token]);

    useEffect(() => {
        if (token) {
            api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=true`)
                .then(r => setBancos(r.data))
                .catch(() => setBancos([]));
        }
    }, [token]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const locacaoId = searchParams.get('locacao');
        const pagamentoId = searchParams.get('id');
        const pendentesParam = searchParams.get('Pendentes');
        const dataInicioParam = searchParams.get('dataInicio');
        const dataFimParam = searchParams.get('dataFim');
        const statusParam = searchParams.get('status');

        if (!filtroInicialAplicado) {
            let dataInicio = null;
            let dataFim = null;
            let status = StatusPagamento.Todos;
            let buscarPendentes = pendentesParam === 'true';

            // Hora LOCAL: new Date("YYYY-MM-DD") é meia-noite UTC e, serializada com "Z", a API lê o dia anterior.
            if (dataInicioParam) dataInicio = parseDateFromString(dataInicioParam);
            if (dataFimParam) dataFim = parseDateFromString(dataFimParam);
            if (statusParam) status = parseInt(statusParam) as StatusPagamento;

            if (buscarPendentes && !dataFim) {
                const { endOfWeek } = getWeekRange(new Date());
                dataFim = endOfWeek;
            }

            const novosFiltros = {
                dataInicio: dataInicio,
                dataFim: dataFim,
                status: status,
                buscarPendentes: buscarPendentes,
                idLocacao: locacaoId || "",
                idLocatario: "",
                idVeiculo: "",
                id: pagamentoId || "",
                tipoPeriodo: tipoPeriodoAtual,
                statusLocacao: "todas" as "todas" | "ativas" | "encerradas"
            };

            setFiltrosAtuais(novosFiltros);
            setFiltrosAplicados(novosFiltros);
            setFiltroInicialAplicado(true);

            carregarPagamentos(novosFiltros, 0, paginationModel.pageSize);
        }
    }, [location.search, filtroInicialAplicado, tipoPeriodoAtual]);

    useEffect(() => {
        if (!filtroInicialAplicado) return;
        carregarPagamentos(filtrosAplicados, paginationModel.page, paginationModel.pageSize);
    }, [paginationModel, filtrosAplicados]);

    // Mapeia a opção do filtro "Status da Locação" para o valor do enum TipoStatusLocacao no backend.
    // "todas" => sem filtro; "ativas" => Ativa (1); "encerradas" => Encerrada (3).
    const statusLocacaoParaQuery = (sl?: "todas" | "ativas" | "encerradas"): string | null => {
        if (sl === "ativas") return "1";
        if (sl === "encerradas") return "3";
        return null;
    };

    const carregarPagamentos = (filtros: typeof filtrosAplicados, page: number, pageSize: number) => {
        if (!temPermissao) return;

        const carregarLista = async () => {
            setCarregando(true);
            try {
                const pageToSend = page + 1;
                const paramsListagem = new URLSearchParams();
                paramsListagem.append('page', pageToSend.toString());
                paramsListagem.append('pageSize', pageSize.toString());

                if (filtros.id) {
                    const response = await api.get(`/Pagamento/${filtros.id}`);
                    processResponse(response);
                    return; // Early exit
                }

                let urlListagem = `/Pagamento/Filtrar`;
                if (filtros.buscarPendentes) {
                    const dataFimStr = filtros.dataFim ? filtros.dataFim.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
                    urlListagem = `/PorEmpresaPorIntervaloPendente/${obterIdTenent(token)}/${dataFimStr}`;
                    paramsListagem.append('page', pageToSend.toString());
                    paramsListagem.append('pageSize', pageSize.toString());
                } else {
                    paramsListagem.append('idEmpresa', obterIdTenent(token));
                    if (filtros.idLocacao) paramsListagem.append('idLocacao', filtros.idLocacao);
                    if (filtros.idLocatario) paramsListagem.append('idLocatario', filtros.idLocatario);
                    if (filtros.idVeiculo) paramsListagem.append('idVeiculo', filtros.idVeiculo);
                    if (filtros.dataInicio) paramsListagem.append('dataInicial', filtros.dataInicio.toISOString().split('T')[0]);
                    if (filtros.dataFim) paramsListagem.append('dataFinal', filtros.dataFim.toISOString().split('T')[0]);
                    if (filtros.status !== StatusPagamento.Todos) paramsListagem.append('status', filtros.status.toString());
                    if (filtros.tipoPeriodo === "pagamento") paramsListagem.append('tipoPeriodo', 'pagamento');
                    const slListagem = statusLocacaoParaQuery(filtros.statusLocacao);
                    if (slListagem) paramsListagem.append('statusLocacao', slListagem);
                }

                const responseListagem = await api.get(`${urlListagem}?${paramsListagem.toString()}`);
                processResponse(responseListagem);
            } catch (error: any) {
                tratarErro(error);
            } finally {
                setCarregando(false);
            }
        };

        const carregarResumo = async () => {
            if (filtros.id) { // Não carrega resumo se busca por ID específico
                setTotalizadoresBackend({ pagos: { valor: 0, quantidade: 0 }, aVencer: { valor: 0, quantidade: 0 }, emAtraso: { valor: 0, quantidade: 0 }, locatarios: 0 });
                return;
            };
            setCarregandoResumo(true);
            try {
                const paramsResumo = new URLSearchParams();
                paramsResumo.append('idEmpresa', obterIdTenent(token));

                const aplicarFiltrosComuns = (params: URLSearchParams) => {
                    if (filtros.idLocacao) params.append('idLocacao', filtros.idLocacao);
                    if (filtros.idLocatario) params.append('idLocatario', filtros.idLocatario);
                    if (filtros.idVeiculo) params.append('idVeiculo', filtros.idVeiculo);
                    if (filtros.dataInicio) params.append('dataInicial', filtros.dataInicio.toISOString().split('T')[0]);
                    if (filtros.dataFim) params.append('dataFinal', filtros.dataFim.toISOString().split('T')[0]);
                    if (filtros.status !== StatusPagamento.Todos) params.append('status', filtros.status.toString());
                    if (filtros.tipoPeriodo === "pagamento") params.append('tipoPeriodo', 'pagamento');
                    const slResumo = statusLocacaoParaQuery(filtros.statusLocacao);
                    if (slResumo) params.append('statusLocacao', slResumo);
                };

                let urlResumo = `/Pagamento/Resumo`;

                if (filtros.buscarPendentes) {
                    const dataFimStr = filtros.dataFim ? filtros.dataFim.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
                    paramsResumo.append('dataFinal', dataFimStr);
                } else {
                    aplicarFiltrosComuns(paramsResumo);
                }

                const responseResumo = await api.get(`${urlResumo}?${paramsResumo.toString()}`);

                if (responseResumo.data) {
                    const dados = responseResumo.data;
                    setTotalizadoresBackend({
                        pagos: { valor: dados.pagos?.valor || dados.Pagos?.Valor || 0, quantidade: dados.pagos?.quantidade || dados.Pagos?.Quantidade || 0 },
                        aVencer: { valor: dados.aVencer?.valor || dados.AVencer?.Valor || 0, quantidade: dados.aVencer?.quantidade || dados.AVencer?.Quantidade || 0 },
                        emAtraso: { valor: dados.emAtraso?.valor || dados.EmAtraso?.Valor || 0, quantidade: dados.emAtraso?.quantidade || dados.EmAtraso?.Quantidade || 0 },
                        locatarios: dados.totalLocatarios || dados.TotalLocatarios || 0
                    });
                }
            } catch (error: any) {
                console.error("Erro ao carregar resumo:", error);
                setTotalizadoresBackend({ pagos: { valor: 0, quantidade: 0 }, aVencer: { valor: 0, quantidade: 0 }, emAtraso: { valor: 0, quantidade: 0 }, locatarios: 0 });
            } finally {
                setCarregandoResumo(false);
            }
        };

        carregarLista();
        carregarResumo();
    };

    const processResponse = (response: any) => {
        if (response.data.items) {
            setPagamentos(response.data.items);
            setRowCount(response.data.totalCount);
        } else {
            const data = Array.isArray(response.data) ? response.data : [response.data];
            setPagamentos(data);
            setRowCount(data.length);
        }
    };

    // Roteia o item selecionado na busca combinada (value prefixado) para o filtro correto.
    // "loc:<id>" | "lct:<id>" | "vei:<id>"; sem prefixo = locacao (retrocompat).
    const resolverItemBusca = (itensSelecionados?: (string | number)[]) => {
        let idLocacao = "", idLocatario = "", idVeiculo = "";
        if (itensSelecionados && itensSelecionados.length > 0) {
            const sel = String(itensSelecionados[0]);
            if (sel.startsWith("lct:")) idLocatario = sel.slice(4);
            else if (sel.startsWith("vei:")) idVeiculo = sel.slice(4);
            else if (sel.startsWith("loc:")) idLocacao = sel.slice(4);
            else idLocacao = sel;
        }
        return { idLocacao, idLocatario, idVeiculo };
    };

    const handleBuscar = useCallback(async (
        dataIni: Date | null,
        dataFim: Date | null,
        status: StatusPagamento,
        buscarPendentes?: boolean,
        itensSelecionados?: (string | number)[],
        tipoPeriodo?: "vencimento" | "pagamento",
        statusLocacao?: "todas" | "ativas" | "encerradas"
    ) => {

        const { idLocacao, idLocatario, idVeiculo } = resolverItemBusca(itensSelecionados);

        if (buscarPendentes) {
            if (!dataFim) {
                const { endOfWeek } = getWeekRange(new Date());
                dataFim = endOfWeek;
            }
        }

        setTipoPeriodoAtual(tipoPeriodo || "vencimento");

        const novosFiltros = {
            dataInicio: dataIni,
            dataFim: dataFim,
            status: status,
            buscarPendentes: buscarPendentes || false,
            idLocacao: idLocacao,
            idLocatario: idLocatario,
            idVeiculo: idVeiculo,
            id: "",
            tipoPeriodo: tipoPeriodo || "vencimento",
            statusLocacao: statusLocacao || "todas"
        };

        setFiltrosAtuais(novosFiltros);
        setFiltrosAplicados(novosFiltros);
        setPaginationModel(prev => ({ ...prev, page: 0 }));

        await carregarPagamentos(novosFiltros, 0, paginationModel.pageSize);
    }, [paginationModel.pageSize]);

    const reaplicarFiltrosAtuais = async () => {
        await carregarPagamentos(filtrosAplicados, paginationModel.page, paginationModel.pageSize);
    };

    const colunas = [
        {
            field: 'locacao',
            headerName: 'Locação',
            flex: 1.5,
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                if (!params.row.locacao) return <Typography variant="body2">Locação não encontrada</Typography>;

                const { locatario, veiculo } = params.row.locacao;

                const getVehicleIcon = () => {
                    switch (Number(veiculo.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };

                const veiculoLabel = `${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo}`;

                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <FiUser size={16} />
                            <Typography variant="body2">{locatario.nome}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                            {getVehicleIcon()}
                            <Typography variant="body2">{veiculoLabel}</Typography>
                        </Box>
                    </Box>
                );
            }
        },
        {
            field: 'dataPrevista',
            headerName: 'Vencimento',
            flex: 0.7,
            valueGetter: (params: any) => new Date(params.value),
            renderCell: renderData
        },
        {
            field: 'dataPagamentoRealizado',
            headerName: 'Pagamento',
            flex: 0.7,
            valueGetter: (params: any) => new Date(params.value),
            renderCell: renderData
        },
        {
            field: 'valor',
            headerName: 'Valor',
            flex: 1,
            renderCell: (params: any) => {
                const estiloIconeValor: React.CSSProperties = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, marginLeft: 4 };
                let color = 'gray';
                let title = 'Nota não emitida';

                const temNotaEmitida = params.row.nfService?.id &&
                    params.row.nfService.id !== '00000000-0000-0000-0000-000000000000';

                if (temNotaEmitida) {
                    switch (params.row.nfService.status) {
                        case 0: color = 'orange'; title = 'Processando'; break;
                        case 1: color = 'green'; title = 'Emitida'; break;
                        case 2: color = 'red'; title = 'Cancelada'; break;
                        case 3: color = 'red'; title = 'Erro'; break;
                        default: color = 'gray'; break;
                    }
                }

                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        {formatarParaReais(params.value)}

                        {params.row.asaasPaymentId && (
                            <Tooltip title="Integrado ao Asaas" arrow>
                                <img
                                    src={asaasLogo}
                                    alt="Asaas"
                                    style={{ width: 18, height: 18, objectFit: "contain", cursor: "pointer" }}
                                />
                            </Tooltip>
                        )}

                        {params.row.temDivergenciaAsaas && (
                            <Tooltip title="Falta de conciliação: a fatura está paga no Asaas, mas o pagamento está pendente/cancelado aqui. Use a ação 'Corrigir Divergência' para conciliar." arrow>
                                <span style={estiloIconeValor}>
                                    <FaFlag color="#dc3545" size={14} style={{ cursor: 'pointer' }} />
                                </span>
                            </Tooltip>
                        )}

                        {temNotaEmitida && (
                            <Tooltip title={`Nota Fiscal: ${title}`} arrow>
                                <span style={estiloIconeValor}>
                                    <FaFileInvoiceDollar color={color} size={16} style={{ cursor: 'pointer' }} />
                                </span>
                            </Tooltip>
                        )}

                        {emissaoLiberada && !temNotaEmitida && (
                            <Tooltip title="Nota Fiscal: Não Emitida" arrow>
                                <span style={estiloIconeValor}>
                                    <FaFileInvoice
                                        color="gray"
                                        size={16}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleEmitirNota(params.row)}
                                    />
                                </span>
                            </Tooltip>
                        )}
                    </Box>
                );
            }
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            renderCell: (params: any) => {
                const status = params.value;
                const statusText = converterStatusPagamentoParaTexto(status);
                let backgroundColor;
                if (status === StatusPagamento.Pago) backgroundColor = '#2F855A';
                else if (status === StatusPagamento.Pendente) backgroundColor = '#FFC107';
                else backgroundColor = '#C53030';

                return (
                    <span style={{
                        backgroundColor,
                        color: 'white',
                        padding: '3px 10px',
                        borderRadius: '4px',
                        fontWeight: 600,
                        fontSize: '0.72rem',
                        letterSpacing: '0.4px',
                        textTransform: 'uppercase',
                        textAlign: 'center',
                        whiteSpace: 'nowrap'
                    }}>
                        {statusText}
                    </span>
                );
            }
        },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade', flex: 1,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const filial = filiaisOptions.find((f: any) => f.valor === params.value);
                return filial?.label || '';
            }
        }] : []),
    ];

    function renderData(params: any) {
        const diasDaSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return '';

        const diaSemana = diasDaSemana[date.getDay()];
        const dataFormatada = date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });

        const resetHora = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

        const hoje = resetHora(new Date());
        const comparada = resetHora(date);

        let textoExtra = `(${diaSemana})`;
        const diffMs = comparada.getTime() - hoje.getTime();
        const diffDias = diffMs / (1000 * 60 * 60 * 24);

        if (diffDias === -1) textoExtra = "(Ontem)";
        else if (diffDias === 0) textoExtra = "(Hoje)";
        else if (diffDias === 1) textoExtra = "(Amanhã)";
        else textoExtra = `(${diaSemana})`;

        return (
            <Box display="flex" flexDirection="column" lineHeight={1.2} alignItems={isMobile ? "start" : "center"}>
                <span>{dataFormatada}</span>
                <span style={{ fontSize: '13px', color: '#888' }}>{textoExtra}</span>
            </Box>
        );
    }

    const handleEmitirNota = async (pagamento: any) => {
        if (pagamento.status != StatusPagamento.Pago) {
            const confirma = await confirm("Esse pagamento ainda não foi marcado como recebido/pago. Deseja realmente emitir a Nota Fiscal para ele?");
            if (!confirma) {
                return;
            }
        }

        setCarregando(true);
        try {
            const configResponse = await api.get(`/ConfiguracaoPorEmpresa/${obterIdTenent(token)}`);
            const config = configResponse.data;

            const dados = {
                idPagamento: pagamento.id,
                idLocatario: pagamento.locacao.locatario.id,
                valor: await obterValorCobranca(pagamento.id),
                pagamento: pagamento
            };

            if (config.usarServicoPadraoNFSe) {
                const servicosResponse = await api.get(`/ServicoNFSePorEmpresa/${obterIdTenent(token)}`);
                const servicos = servicosResponse.data;
                const servicoPadrao = servicos.find((s: any) => s.padrao);

                if (servicoPadrao) {
                    await emitirNota(dados, servicoPadrao.id);
                } else {
                    toast.info("Nenhum serviço padrão encontrado. Selecione um serviço.");
                    setDadosParaEmitirNota(dados);
                    setShowModalEmitirNota(true);
                }
            } else {
                setDadosParaEmitirNota(dados);
                setShowModalEmitirNota(true);
            }
        } catch (error: any) {
            console.error(error);
            toast.error("Erro ao verificar configurações: " + (error.response?.data?.Mensagem || error.message));
        } finally {
            setCarregando(false);
        }
    };

    const emitirNota = async (dados: any, idServico: string) => {
        try {
            setCarregando(true);
            await NFServiceService.emitir(
                dados.idPagamento,
                idServico,
                obterIdTenent(token),
                dados.idLocatario,
                dados.valor
            );

            setShowModalEmitirNota(false);

            toast.success('Iniciando Emissão da Nota Fiscal')

            await reaplicarFiltrosAtuais();
        } catch (error: any) {
            tratarErro(error)
        } finally {
            setCarregando(false);
        }
    }

    // Valor devido pelo locatário (integral + juros/multa), calculado no servidor por id.
    // A grade NÃO serve de fonte para baixa/edição, cobrança ou NF: para usuário comissionado
    // (não-admin com vínculo de filial) ela exibe a comissão da filial, não o valor da parcela.
    const obterValorCobranca = async (idPagamento: string): Promise<number> => {
        const response = await api.get(`/Pagamento/ValorCobranca/${idPagamento}`);
        return response.data;
    };

    const handleConfirmarRapidoPagamento = async (pagamento: any) => {
        setCarregando(true);
        try {
            await api.put(`/AtualizarPagamento/${pagamento.id}/${StatusPagamento.Pago}`);
            await reaplicarFiltrosAtuais();
            setCarregando(false);
            toast.success('Pagamento confirmado com sucesso');

            // Marcar step do onboarding como concluído
            api.post(`/OnboardingStepComplete/${obterIdTenent(token)}/pagamentosBaixados`).catch(() => {});

            if (podeEmitirNota && emissaoLiberada && pagamento.nfService?.id === '00000000-0000-0000-0000-000000000000') {
                if(configuracao?.usarServicoPadraoNFSe) {
                    await handleEmitirNota({ ...pagamento, status: StatusPagamento.Pago });
                } else {
                    if (await confirm("Deseja emitir a Nota Fiscal para este pagamento?")) {
                        await handleEmitirNota({ ...pagamento, status: StatusPagamento.Pago });
                    }
                }
            }

            if (pagamento?.ehUltimoPagamento) {
                if (await confirm("Esse foi o último pagamento desse Contrato de Locação\nDeseja adicionar novas pendências de pagamentos para essa locação?", { alert: true, waitSeconds: 3, sound: true })) {
                    setPagamentoSelecionado(pagamento);
                    api.get(`/Locacao/${pagamento.idLocacao}`).then((response) => {
                        if (response.data) {
                            setLocacaoSelecionado(response.data);
                            handleSimModalSimNao();
                        }
                    }).catch((error) => {
                        tratarErro(error);
                    })
                }
            }
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleExcluirPagamento = async (idPagamento: string) => {
        setShowModalConfirmarExclusao(false);
        setCarregando(true);
        try {
            await api.delete(`/Pagamento/${idPagamento}`);
            await reaplicarFiltrosAtuais();
            setCarregando(false);
            toast.success('Pagamento excluído com sucesso.');
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleConfirmarPagamento = async (dados: {
        valor: number;
        gerarPendencia: boolean;
        dataPagamento: string;
        dataVencimentoPendencia: string | null;
        motivoPagamento: string;
        motivoPendencia: string;
        valorPendencia: number;
        marcarPagamentoOrigemComoPago: boolean;
        alterarVencimentoOriginal: boolean;
        novaDataVencimentoOriginal: string | null;
        confirmarPagamento: boolean;
        naoContabilizarJuros: boolean;
        naoContabilizarMulta: boolean;
        idBanco?: string | null;
    }) => {
        let valorDaPendencia;
        let dataPrevista = dados.novaDataVencimentoOriginal || pagamentoSelecionado.dataPrevista;
        if (dados.gerarPendencia) {
            valorDaPendencia = dados.valorPendencia;
            dataPrevista = dados.dataVencimentoPendencia;
        }

        // Sem fallback para o valor da grade: para usuário comissionado ela exibe a comissão da
        // filial, e um campo zerado acabaria gravando a comissão como valor da parcela.
        if (!dados.gerarPendencia && (!dados.valor || dados.valor <= 0)) {
            toast.error('Informe um valor válido para o pagamento.');
            return;
        }

        const status = dados.confirmarPagamento ? StatusPagamento.Pago : pagamentoSelecionado.status;
        
        const ehPagoResultante = status === StatusPagamento.Pago;
        const dataRecebimentoFinal = ehPagoResultante
            ? (dados.dataPagamento || pagamentoSelecionado.dataPagamentoRealizado || new Date().toISOString().split('T')[0])
            : pagamentoSelecionado.dataPagamentoRealizado;

        let pagamentoASalvar: Pagamento = {
            idLocacao: pagamentoSelecionado.idLocacao,
            ehUltimoPagamento: false,
            status: status,
            idEmpresa: pagamentoSelecionado.idEmpresa,
            valor: valorDaPendencia || dados.valor,
            descricao: dados.gerarPendencia ? dados.motivoPendencia : dados.motivoPagamento || pagamentoSelecionado.descricao,
            dataPrevista: dataPrevista,
            dataPagamentoRealizado: dataRecebimentoFinal,
            id: pagamentoSelecionado.id,
            asaasPaymentId: pagamentoSelecionado.asaasPaymentId,
            gerarApenasNoAsaas: !!pagamentoSelecionado?.asaasPaymentId && dados.gerarPendencia,
            naoContabilizarJuros: dados.naoContabilizarJuros,
            naoContabilizarMultas: dados.naoContabilizarMulta,
            idBanco: dados.idBanco ?? pagamentoSelecionado.idBanco ?? null,
        }

        if (dados.confirmarPagamento) {
            pagamentoASalvar.naoEditarNoAsaas = true;
        }

        try {
            if (!dados.gerarPendencia) {
                if (dados.alterarVencimentoOriginal) {
                    pagamentoASalvar.dataPrevista = parseDateFromString(dados.novaDataVencimentoOriginal || "") || new Date();
                }
                await atualizarPagamento(pagamentoASalvar);
            } else {
                const origemResultaPago = dados.marcarPagamentoOrigemComoPago;
                const pagamentoDeOrigem = {
                    idLocacao: pagamentoSelecionado.idLocacao,
                    ehUltimoPagamento: false,
                    status: origemResultaPago ? StatusPagamento.Pago : StatusPagamento.Pendente,
                    idEmpresa: pagamentoSelecionado.idEmpresa,
                    valor: dados.valor,
                    descricao: dados.motivoPagamento || pagamentoSelecionado.descricao,
                    dataPrevista: dados.alterarVencimentoOriginal ? parseDateFromString(dados.novaDataVencimentoOriginal || "") : pagamentoSelecionado.dataPrevista,
                    dataPagamentoRealizado: origemResultaPago ? (dados.dataPagamento || pagamentoSelecionado.dataPagamentoRealizado || new Date().toISOString().split('T')[0]) : pagamentoSelecionado.dataPagamentoRealizado,
                    id: pagamentoSelecionado.id,
                    asaasPaymentId: pagamentoSelecionado.asaasPaymentId
                }
                await atualizarPagamento(pagamentoDeOrigem);
            }

            // Só chega aqui se a atualização acima NÃO lançou (atualizarPagamento relança em erro).
            if (dados.gerarPendencia && dados.valorPendencia > 0) {
                try {
                    pagamentoASalvar.id = undefined;
                    pagamentoASalvar.asaasPaymentId = undefined;
                    pagamentoASalvar.status = StatusPagamento.Pendente;
                    await api.post(`/Pagamento/`, pagamentoASalvar);
                    await reaplicarFiltrosAtuais();
                    toast.info("Pendência gerada com sucesso");
                } catch (error: any) {
                    tratarErro(error);
                    toast.warning("A baixa foi registrada, mas a pendência do valor restante não foi confirmada. Confira a lista antes de criá-la manualmente (não repita a baixa).");
                }
            }
            await reaplicarFiltrosAtuais();

            // Marcar step do onboarding como concluído
            api.post(`/OnboardingStepComplete/${obterIdTenent(token)}/pagamentosBaixados`).catch(() => {});

            if (podeVerNota && pagamentoSelecionado.nfService && pagamentoSelecionado.nfService.id && pagamentoSelecionado.nfService.id !== '00000000-0000-0000-0000-000000000000') {
                if (await confirm("Pagamento baixado com sucesso! Este pagamento possui Nota Fiscal emitida. Deseja visualizar?")) {
                    window.location.href = `/notas-fiscais?idPagamento=${pagamentoSelecionado.id}`;
                }
            } else if (podeEmitirNota && emissaoLiberada && configuracao?.usarServicoPadraoNFSe) {
                if (await confirm("Pagamento baixado com sucesso! Deseja emitir a Nota Fiscal agora?")) {
                    const pagamentoParaEmitir = {
                        ...pagamentoSelecionado,
                        status: StatusPagamento.Pago,
                        valor: pagamentoASalvar.valor
                    };
                    await handleEmitirNota(pagamentoParaEmitir);
                }
            }
        } catch (error) {
            throw error;
        }
    };

    const handleParcelar = async (dados: {
        parcelas: { num: number; data: string; valor: number; naoContabilizarJuros: boolean; naoContabilizarMultas: boolean }[];
        descricao: string;
        excluirOriginal: boolean;
    }) => {
        try {
            const totalParcelas = dados.parcelas.length;
            const integradoAsaas = !!pagamentoSelecionado?.asaasPaymentId;

            // Gerar as parcelas. Cada POST cria uma cobrança real no Asaas quando integrado; em falha no
            // meio do lote, as já criadas continuam válidas — o aviso abaixo diz exatamente quantas, para
            // o operador NÃO repetir o parcelamento inteiro (duplicaria boletos).
            let parcelasCriadas = 0;
            for (const parcela of dados.parcelas) {
                const novaParcela = {
                    idLocacao: pagamentoSelecionado.idLocacao,
                    idEmpresa: pagamentoSelecionado.idEmpresa,
                    valor: parcela.valor,
                    descricao: `${dados.descricao} ${parcela.num}/${totalParcelas}`,
                    dataPrevista: parcela.data,
                    status: StatusPagamento.Pendente,
                    ehUltimoPagamento: false,
                    naoContabilizarJuros: parcela.naoContabilizarJuros,
                    naoContabilizarMultas: parcela.naoContabilizarMultas,
                    gerarApenasNoAsaas: integradoAsaas,
                };

                try {
                    await api.post(`/Pagamento/`, novaParcela);
                    parcelasCriadas++;
                } catch (error: any) {
                    await reaplicarFiltrosAtuais();
                    if (parcelasCriadas > 0) {
                        toast.warning(`${parcelasCriadas} de ${totalParcelas} parcelas foram geradas antes da falha e já aparecem na lista. NÃO repita o parcelamento: confira a lista e gere manualmente só as que faltarem. O pagamento original não foi excluído.`);
                    }
                    throw error;
                }
            }

            // Excluir pagamento original (ele foi parcelado)
            if (dados.excluirOriginal && pagamentoSelecionado.id) {
                await api.delete(`/Pagamento/${pagamentoSelecionado.id}`);
            }

            await reaplicarFiltrosAtuais();
            if (integradoAsaas) {
                // O vínculo com a cobrança do Asaas pode chegar alguns segundos depois (webhook);
                // recarrega de novo para a grid mostrar o status de integração atualizado.
                setTimeout(async () => {
                    await reaplicarFiltrosAtuais();
                }, 3000);
            }
            toast.success(`${totalParcelas} parcelas geradas com sucesso!`);
        } catch (error: any) {
            tratarErro(error);
            throw error;
        }
    };

    const handleConciliarComAsaas = async (idPagamento: string) => {
        setCarregando(true);
        try {
            await api.put(`/Pagamento/${idPagamento}/ConciliarComAsaas`);
            await reaplicarFiltrosAtuais();
            setCarregando(false);
            toast.success("Divergência corrigida: pagamento conciliado com o status do Asaas.");
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleCancelarPagamento = async (idPagamento: string) => {
        setCarregando(true);
        try {
            await api.put(`/AtualizarPagamento/${idPagamento}/${StatusPagamento.Pendente}`);
            await reaplicarFiltrosAtuais();
            setCarregando(false);
            toast.success("Pagamento cancelado com sucesso");
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const atualizarPagamento = async (pagamento: Pagamento) => {
        setCarregando(true);
        try {
            await api.put(`/Pagamento/`, pagamento);
            await reaplicarFiltrosAtuais();
            toast.success("Pagamento atualizado com sucesso");
        } catch (error: any) {
            tratarErro(error);
            // Relança: quem chama (baixa parcial com pendência, por exemplo) NÃO pode seguir como se a
            // atualização tivesse acontecido — antes a pendência era criada mesmo com a baixa falha,
            // e o locatário ficava devendo a parcela inteira mais a pendência.
            throw error;
        } finally {
            setCarregando(false);
        }
    };

    const handleSimModalSimNao = async () => {
        if (pagamentoSelecionado && temPermissaoCriar) {
            setExibirFormModalPagamentos(true);
            setShowModalSimNao(false);
        }
    };

    const camposPagamentos: Campo[] = [
        { label: 'Informações da Locação', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true, },
        {
            label: 'Locatário', nome: 'idLocatario', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 2, visible: true, opcoes: locatariosOptions, apenasLeitura: true
        },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 3, visible: true, opcoes: veiculosOptions, apenasLeitura: true
        },
        { label: 'Informações do Pagamento', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 4, visible: true, },
        {
            label: 'Deseja prolongar por mais quanto tempo?', nome: 'tempoContratoEmMeses', required: true, tipo: 'selectwithnumber', largura: 8, coluna: 1, linha: 5,
            visible: true, ajudinha: {
                texto: "Este campo representa a duração do contrato, que pode ser expressa em dias, semanas, quinzenas ou meses.",
                autoCloseTime: 3
            }, opcoes: opcoesPrazoMinimo
        },
        {
            label: "Desejo gerar Pagamento único", coluna: 1, largura: 12, linha: 6, visible: () => {
                if (locacaoSelecionado.periodicidadePagamento == TipoPeriodicidadePagamento.Diario) {
                    return true;
                }
                return false;
            },
            onCampoDigitar(e) {
                setGeraPagamentoUnico(e);
            },
            nome: 'desejoGerarPagamentoUnico', tipo: 'checkbox', required: false, ajudinha: { texto: "Utilize esta opção para gerar um único pagamento referente à locação. Mesmo que seja informada uma periodicidade diária, o sistema irá considerar apenas um pagamento." },
        },
        {
            label: 'Data de Pagamento único', nome: 'dataPagamento', required: geraPagamentoUnico, tipo: 'date', largura: 4, coluna: 2, linha: 7, visible: () => {
                if (locacaoSelecionado.periodicidadePagamento == TipoPeriodicidadePagamento.Diario) {
                    return true;
                }
                return false;
            }, ajudinha: {
                texto: "Este campo indica a data do pagamento único",
                autoCloseTime: 3
            }, apenasLeitura: !geraPagamentoUnico
        },
    ];

    const onSavePagamentos = async (entidade: any, deveValidarId?: Boolean) => {
        if (isSavingPagamentos) return;
        setIsSavingPagamentos(true);

        const pagamentoUnico = entidade.desejoGerarPagamentoUnico;
        const dataPagamento = entidade.dataPagamento;

        let tipoPeriodicidade = entidade.tempoContratoEmMeses.unit;

        if (!tipoPeriodicidade) {
            tipoPeriodicidade = TipoPeriodicidadePagamento.Diario;
        }

        let quantidade = entidade.tempoContratoEmMeses.value;
        if (!quantidade) {
            quantidade = 1;
        }

        const queryParams = new URLSearchParams();

        if (pagamentoUnico !== undefined) queryParams.append("pagamentoUnico", pagamentoUnico);
        // Só o dia, como string: new Date("YYYY-MM-DD") é meia-noite UTC e, com "Z", a API lê o dia anterior.
        if (dataPagamento) queryParams.append("dataPagamento", String(dataPagamento).substring(0, 10));

        if (tipoPeriodicidade !== undefined) {
            queryParams.append("tipoPeriodicidade", tipoPeriodicidade.toString());
        }

        try {
            const response = await api.post(`/CriarPagamentosPrevistosPorTempo/${pagamentoSelecionado.idLocacao}/${quantidade}?${queryParams.toString()}`);
            setCarregando(false);
            setIsSavingPagamentos(false);
            const avisoAsaas = response?.data?.avisoAsaas ?? response?.data?.AvisoAsaas;
            if (avisoAsaas) {
                toast.warning(avisoAsaas, { autoClose: false });
            } else {
                toast.success('Pagamentos criados com sucesso.');
            }
            reaplicarFiltrosAtuais();
        } catch (error: any) {
            tratarErro(error);
        }
        setExibirFormModalPagamentos(false);
    };

    const atualizarCamposPagamentos = () => {
        setVeiculosOptions([{ label: labelComFilial(`${locacaoSelecionado.veiculo.placa} - ${locacaoSelecionado.veiculo.marca} - ${locacaoSelecionado.veiculo.modelo} - ${locacaoSelecionado.veiculo.ano}`, locacaoSelecionado.veiculo.idFilial), valor: locacaoSelecionado.veiculo.id }]);
        setLocatariosOptions([{ label: labelComFilial(`${locacaoSelecionado.locatario.documento} - ${locacaoSelecionado.locatario.nome}`, locacaoSelecionado.locatario.idFilial), valor: locacaoSelecionado.locatario.id }]);
        setEntidadeParaAtualizarPagamentos({
            tipoPeriodicidadeTempoContrato: locacaoSelecionado.tipoPeriodicidadeTempoContrato,
            tempoContratoEmMeses: locacaoSelecionado.tempoContratoEmMeses,
            idLocatario: locacaoSelecionado.locatario.id,
            idVeiculo: locacaoSelecionado.veiculo.id,
        });
        setForcarAtualizacaoDeEntidadeNoModalPagamentos(true);
    };

    const tratarErro = (error: AxiosError<ApiError>) => {
        setCarregando(false);
        setShowModalConfirmarExclusao(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação Pagamento: ${errorMessage}`);
    };

    const fetchConfiguracao = async (): Promise<ConfiguracaoEmpresa | null> => {
        try {
            const [configResp, empresaResp] = await Promise.all([
                api.get(`ConfiguracaoPorEmpresa/${obterIdTenent(token)}`),
                api.get(`Empresa/${obterIdTenent(token)}`)
            ]);
            const data = configResp.data;
            setMensagemCobrancaWhatsApp(data.mensagemWhatsAppCobranca);
            setChavePix(data.chavePix);
            setConfiguracao(data);
            setEmissaoLiberada(
                empresaResp.data?.emissaoNotaFiscalLiberada
                || data?.empresa?.emissaoNotaFiscalLiberada
                || false
            );
            return data;
        } catch (error: any) {
            console.error(error);
            return null;
        }
    };

    const handleCobrarPagamento = async (pagamento: any) => {
        let mensagem = mensagemCobrancaWhatsApp;
        let chave = chavePix;

        const telefone = pagamento.locacao.locatario.telefone;
        if (!telefone) {
            toast.error("Não é possível enviar a mensagem pois este locatário não possui um telefone cadastrado. Para atualizar, acesse: Cadastros > Locação > Locatário e edite o cadastro informando um número de telefone.");
            return;
        }

        // Usa a configuração RESOLVIDA pela filial selecionada (header X-Filial-Id).
        // Assim a mensagem/chave refletem a filial em uso; cai para a config da empresa em caso de falha.
        let configuracao: any = null;
        try {
            const resp = await api.get('ConfiguracaoFilial/ResolvidaAtual');
            configuracao = resp.data;
        } catch {
            configuracao = await fetchConfiguracao();
        }
        mensagem = configuracao?.mensagemWhatsAppCobranca || "";
        chave = configuracao?.chavePix || "";

        if (!mensagem) {
            toast.info("Acesse o seu Perfil > Configuração > WhatsApp e personalize a sua mensagem de cobrança");
            mensagem = `Olá, {nome_locatario}, regularize a sua pendência no valor de {valor} e com vencimento para o dia {vencimento}`;
        }

        const telefoneNumerico = telefone.replace(/\D/g, '');
        if (telefoneNumerico.length < 10) {
            toast.info("Telefone inválido para envio via WhatsApp.");
            return;
        }

        const telefoneWhatsApp = `55${telefoneNumerico}`;

        if ((mensagem.toLowerCase().includes("{chave_pix}") || mensagem.toLowerCase().includes("{pix_copia_cola}")) && !chave) {
            toast.error("Você indicou uma chave Pix na mensagem de cobrança, mas não configurou uma. Acesse Seu Perfil > Configuração > Chave Pix para cadastrar uma, ou remova a indicação da chave na mensagem.");
            return;
        }

        let pixCode = "";
        try {
            if (pagamento.asaasPaymentId) {
                const response = await api.get(`/Pagamento/PixAsaas/${pagamento.id}`);
                pixCode = response.data;
            } else if (chave) {
                const response = await api.get(`/Pagamento/PixCopiaCola/${pagamento.id}`);
                pixCode = response.data;
            }
        } catch (error: any) {
            tratarErro(error);
            return;
        }

        // {valor} com o valor devido buscado por id (o PIX acima já é gerado no servidor com essa base)
        let valorCobranca: number;
        try {
            valorCobranca = await obterValorCobranca(pagamento.id);
        } catch (error: any) {
            tratarErro(error);
            return;
        }

        let mensagemFormatada = mensagem
            .replace(/{nome_locatario}/gi, pagamento.locacao.locatario.nome)
            .replace(/{valor}/gi, formatarParaReais(valorCobranca))
            .replace(/{vencimento}/gi, formatDate(pagamento.dataPrevista))
            .replace(/{chave_pix}/gi, chave)
            .replace(/{pix_copia_cola}/gi, pixCode);

        mensagemFormatada = encodeURIComponent(mensagemFormatada);
        const url = `https://api.whatsapp.com/send?phone=${telefoneWhatsApp}&text=${mensagemFormatada}`;
        window.open(url, '_blank');
    };

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModalPagamentos) {
            setForcarAtualizacaoDeEntidadeNoModalPagamentos(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModalPagamentos]);

    useEffect(() => {
        if (triggerBuscar) {
            setTriggerBuscar(false);
        }
    }, [triggerBuscar]);

    const handleObterFatura = async (e: any) => {
        if (!e.asaasPaymentId) {
            toast.error("Não é possível obter Link da Fatura. Esse pagamento não existe no Asaas.");
            return;
        }
        try {
            // Usa o endpoint que resolve a conta Asaas pela filial do registro (FaturaAsaas/{id}),
            // garantindo o link correto quando a filial tem conta Asaas própria.
            const response = await api.get(`/Pagamento/FaturaAsaas/${e.id}`);
            const resultado = response.data;
            setCarregando(false);
            if (resultado) {
                await navigator.clipboard.writeText(resultado);
                toast.success('Link da Fatura copiado para a área de transferência!', { autoClose: 10000 });
            }
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleBaixarTodos = async (filtros: typeof filtrosAtuais) => {
        try {
            setCarregando(true);
            const params = new URLSearchParams();
            // Só o dia, no mesmo formato da listagem: o lote tem que alcançar exatamente o que a tela mostra
            // (o toISOString() completo mandava "Z" e a API recuava o fim do período para o dia anterior).
            if (filtros.dataInicio) params.append('dataInicial', filtros.dataInicio.toISOString().split('T')[0]);
            if (filtros.dataFim) params.append('dataFinal', filtros.dataFim.toISOString().split('T')[0]);

            if (filtros.status !== StatusPagamento.Todos) {
                params.append('status', filtros.status.toString());
            }
            if (filtros.idLocacao) {
                params.append('idLocacao', filtros.idLocacao);
            }
            if (filtros.idLocatario) {
                params.append('idLocatario', filtros.idLocatario);
            }
            if (filtros.idVeiculo) {
                params.append('idVeiculo', filtros.idVeiculo);
            }

            const response = await api.put<{ baixados: number; falhasConfirmacaoAsaas: number; falhasBaixa: number; total: number }>(
                `Pagamento/BaixarTodosPorPeriodo/${obterIdTenent(token)}?${params.toString()}`
            );

            const { baixados = 0, falhasConfirmacaoAsaas = 0, falhasBaixa = 0 } = response.data ?? {};

            if (baixados > 0) {
                setCarregando(false);
                toast.success(`${baixados} pagamento(s) foram baixados com sucesso.`);
                if (falhasConfirmacaoAsaas > 0) {
                    toast.warning(
                        `${falhasConfirmacaoAsaas} pagamento(s) não foram baixados porque o Asaas não confirmou o recebimento. Eles continuam em aberto; tente novamente em instantes.`
                    );
                }
                if (falhasBaixa > 0) {
                    toast.warning(
                        `${falhasBaixa} pagamento(s) não puderam ser baixados e foram ignorados. Tente novamente para reprocessá-los.`
                    );
                }
                setTriggerBuscar(true);
            } else if (falhasBaixa > 0) {
                setCarregando(false);
                toast.error(`Nenhum pagamento foi baixado: ${falhasBaixa} item(ns) falharam ao processar. Tente novamente.`);
            } else {
                toast.info('Nenhum pagamento foi baixado: Confira os filtros e o período escolhido');
                setCarregando(false);
            }
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleCancelarTodos = async (filtros: typeof filtrosAtuais) => {
        try {
            setCarregando(true);
            const params = new URLSearchParams();
            // Só o dia, no mesmo formato da listagem: o lote tem que alcançar exatamente o que a tela mostra
            // (o toISOString() completo mandava "Z" e a API recuava o fim do período para o dia anterior).
            if (filtros.dataInicio) params.append('dataInicial', filtros.dataInicio.toISOString().split('T')[0]);
            if (filtros.dataFim) params.append('dataFinal', filtros.dataFim.toISOString().split('T')[0]);

            if (filtros.status !== StatusPagamento.Todos) {
                params.append('status', filtros.status.toString());
            }
            if (filtros.idLocacao) {
                params.append('idLocacao', filtros.idLocacao);
            }
            if (filtros.idLocatario) {
                params.append('idLocatario', filtros.idLocatario);
            }
            if (filtros.idVeiculo) {
                params.append('idVeiculo', filtros.idVeiculo);
            }

            const response = await api.put<number>(
                `Pagamento/CancelarTodosPorPeriodo/${obterIdTenent(token)}?${params.toString()}`
            );

            const quantidade = response.data;

            if (quantidade > 0) {
                setCarregando(false);
                toast.success(`${quantidade} pagamento(s) foram cancelados com sucesso.`);
                setTriggerBuscar(true);
            } else {
                toast.info('Nenhum pagamento foi cancelado: Confira os filtros e o período escolhido');
                setCarregando(false);
            }
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleAcaoEmLote = async (
        tipo: 'baixar' | 'cancelar',
        dIni: Date | null,
        dFim: Date | null,
        stat: StatusPagamento,
        selItems: (string | number)[]
    ) => {
        await handleBuscar(dIni, dFim, stat, false, selItems);

        const { idLocacao, idLocatario, idVeiculo } = resolverItemBusca(selItems);

        const temEntidade = !!idLocacao || !!idLocatario || !!idVeiculo;
        const temDatas = !!dIni && !!dFim;
        const temStatus = stat !== StatusPagamento.Todos;

        if (!temEntidade && !temDatas && !temStatus) {
            toast.info(`Para realizar ${tipo === 'baixar' ? 'a Baixa' : 'o Cancelamento'} em lote, selecione pelo menos um Filtro: Período, Status, Locação, Locatário ou Veículo.`);
            return;
        }

        setCarregando(true);
        try {
            const paramsResumo = new URLSearchParams();

            if (dIni) paramsResumo.append('dataInicial', dIni.toISOString().split('T')[0]);
            if (dFim) paramsResumo.append('dataFinal', dFim.toISOString().split('T')[0]);

            if (idLocacao) paramsResumo.append('idLocacao', idLocacao);
            if (idLocatario) paramsResumo.append('idLocatario', idLocatario);
            if (idVeiculo) paramsResumo.append('idVeiculo', idVeiculo);
            if (stat !== StatusPagamento.Todos) paramsResumo.append('status', stat.toString());

            paramsResumo.append('acao', tipo);

            const responsePreview = await api.get(`/Pagamento/PreviewProcessamentoEmLote/${obterIdTenent(token)}?${paramsResumo.toString()}`);
            const dados = responsePreview.data;

            setCarregando(false);

            if (!dados || dados.length === 0) {
                toast.info("Não existem pagamentos correspondentes aos filtros para esta ação.");
                return;
            }

            setDadosLote(dados);
            setAcaoLote(tipo);
            setShowModalLote(true);

        } catch (error: any) {
            tratarErro(error);
        }
    };

    const handleEditarValorLote = async (
        dIni: Date | null,
        dFim: Date | null,
        stat: StatusPagamento,
        selItems: (string | number)[]
    ) => {
        const { idLocacao, idLocatario, idVeiculo } = resolverItemBusca(selItems);

        const temAlgumFiltro = !!idLocacao || !!idLocatario || !!idVeiculo || (!!dIni && !!dFim) || stat !== StatusPagamento.Todos;
        if (!temAlgumFiltro) {
            toast.info("Para editar valores em lote, selecione ao menos um filtro: Período, Status, Locação, Locatário ou Veículo.");
            return;
        }

        // A edição em lote atua sobre pagamentos não quitados. Filtrar por data de pagamento não faz
        // sentido nesse caso (pagamentos em aberto não têm data de pagamento), então só permitimos
        // intervalo de datas por VENCIMENTO — evitando uma operação que silenciosamente não afeta nada.
        if (tipoPeriodoAtual === 'pagamento' && dIni && dFim) {
            toast.info("A edição de valor em lote considera a data de vencimento. Altere o filtro de período para 'Vencimento' para ajustar por intervalo de datas.");
            return;
        }

        await handleBuscar(dIni, dFim, stat, false, selItems);

        setCarregandoEditarValor(true);
        try {
            const body = {
                dataInicial: dIni ? dIni.toISOString().split('T')[0] : null,
                dataFinal: dFim ? dFim.toISOString().split('T')[0] : null,
                status: stat !== StatusPagamento.Todos ? stat : null,
                idLocacao: idLocacao || null,
                idLocatario: idLocatario || null,
                idVeiculo: idVeiculo || null,
                // Lote sempre por vencimento (ver validação acima).
                tipoPeriodo: null,
            };

            // Preview do lote com o valor BRUTO (sem juros/multa) — a mesma base que o backend ajusta,
            // para o "valor atual" conferido bater com o que será gravado. Já exclui os pagamentos pagos.
            const resp = await api.post(`/Pagamento/ItensParaAjusteEmLote/${obterIdTenent(token)}`, body);
            const itensAlteraveis = resp.data || [];
            if (itensAlteraveis.length === 0) {
                setCarregandoEditarValor(false);
                toast.info("Não existem pagamentos editáveis correspondentes aos filtros.");
                return;
            }

            // Agrega por locatário para a prévia (etapa 1) do modal.
            const mapa = new Map<string, any>();
            itensAlteraveis.forEach((p: any) => {
                const nome = p.nomeLocatario || 'Sem locatário';
                const atual = mapa.get(nome) || { nomeLocatario: nome, quantidade: 0, valorTotal: 0 };
                atual.quantidade += 1;
                atual.valorTotal += (p.valorAtual || 0);
                mapa.set(nome, atual);
            });
            setDadosEditarValor(Array.from(mapa.values()));

            // Detalhe item a item para a etapa de revisão/confirmação (valor atual → novo).
            setItensEditarValor(itensAlteraveis.map((p: any) => ({
                id: p.id,
                nomeLocatario: p.nomeLocatario || 'Sem locatário',
                descricao: p.descricao,
                vencimento: p.vencimento,
                valorAtual: p.valorAtual || 0,
            })));

            setFiltrosEditarValor({ dataInicio: dIni, dataFim: dFim, status: stat, idLocacao, idLocatario, idVeiculo, tipoPeriodo: 'vencimento' });
            setCarregandoEditarValor(false);
            setShowModalEditarValor(true);
        } catch (error: any) {
            setCarregandoEditarValor(false);
            tratarErro(error);
        }
    };

    const handleConfirmarEditarValor = async (tipoAjuste: string, valorAjuste: number, confirmarBaixa: boolean) => {
        if (!filtrosEditarValor) return;
        setCarregandoEditarValor(true);
        try {
            const f = filtrosEditarValor;
            const body = {
                dataInicial: f.dataInicio ? f.dataInicio.toISOString().split('T')[0] : null,
                dataFinal: f.dataFim ? f.dataFim.toISOString().split('T')[0] : null,
                status: f.status !== StatusPagamento.Todos ? f.status : null,
                idLocacao: f.idLocacao || null,
                idLocatario: f.idLocatario || null,
                idVeiculo: f.idVeiculo || null,
                // Lote sempre por vencimento (pagamentos em aberto não têm data de pagamento).
                tipoPeriodo: null,
                tipoAjuste,
                valorAjuste,
                confirmarBaixa
            };
            const resp = await api.put(`/Pagamento/AjustarValorEmLote/${obterIdTenent(token)}`, body);
            const r = resp.data || {};
            const afetados = r.afetados ?? r.Afetados ?? 0;
            const falhas = r.falhas ?? r.Falhas ?? 0;
            const ignorados = r.ignorados ?? r.Ignorados ?? 0;
            const erros: string[] = r.erros ?? r.Erros ?? [];
            const resumo = `${afetados} pagamento(s) ajustado(s)${confirmarBaixa ? ' e baixado(s)' : ''}.${ignorados ? ` ${ignorados} já pago(s) ignorado(s).` : ''}${falhas ? ` ${falhas} falha(s).` : ''}`;
            if (falhas > 0) {
                toast.warning(`${resumo}${erros.length ? ` Motivo: ${erros[0]}` : ''}`);
            } else {
                toast.success(resumo);
            }
            setShowModalEditarValor(false);
            await reaplicarFiltrosAtuais();
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregandoEditarValor(false);
        }
    };

    const exportOptions = useMemo(() => [
        {
            field: 'locacao',
            headerName: 'Locatário',
            valueGetter: ({ row }: { row: any }) => row.locacao?.locatario?.nome || ''
        },
        {
            field: 'veiculo',
            headerName: 'Veículo',
            valueGetter: ({ row }: { row: any }) => {
                const v = row.locacao?.veiculo;
                return v ? `${v.placa} - ${v.modelo}` : '';
            }
        },
        {
            field: 'dataPrevista',
            headerName: 'Vencimento',
            valueGetter: ({ row }: { row: any }) => row.dataPrevista ? new Date(row.dataPrevista).toLocaleDateString('pt-BR') : ''
        },
        {
            field: 'dataPagamentoRealizado',
            headerName: 'Data Pagamento',
            valueGetter: ({ row }: { row: any }) => row.dataPagamentoRealizado ? new Date(row.dataPagamentoRealizado).toLocaleDateString('pt-BR') : ''
        },
        {
            field: 'valor',
            headerName: 'Valor',
            valueGetter: ({ row }: { row: any }) => formatarParaReais(row.valor)
        },
        { field: 'descricao', headerName: 'Descrição' },
        {
            field: 'status',
            headerName: 'Status',
            valueGetter: ({ row }: { row: any }) => converterStatusPagamentoParaTexto(row.status)
        }
    ], []);

    const camposNovoPagamento: Campo[] = [
        { label: 'Locacao', nome: 'idLocacao', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 1, visible: true, opcoes: locacoesOptions.map(l => ({ label: l.label, valor: l.value })) },
        { label: 'Valor (R$)', nome: 'valor', required: true, tipo: 'money', largura: 6, coluna: 1, linha: 2, visible: true },
        { label: 'Vencimento', nome: 'dataPrevista', required: true, tipo: 'date', largura: 6, coluna: 2, linha: 2, visible: true },
        { label: 'Descricao', nome: 'descricao', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 3, visible: true },
        { label: 'Gerar cobranca no Asaas', nome: 'gerarApenasNoAsaas', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 4, visible: contaIntegradaAsaas,
            ajudinha: { texto: 'Se marcado, a cobranca sera gerada automaticamente no Asaas para o locatario.' }
        },
    ];

    const onSaveNovoPagamento = async (entidade: any) => {
        if (isSavingNovo) return;
        setIsSavingNovo(true);
        try {
            await api.post('/Pagamento/', {
                idLocacao: entidade.idLocacao,
                idEmpresa: obterIdTenent(token),
                valor: Number(entidade.valor),
                descricao: entidade.descricao,
                dataPrevista: entidade.dataPrevista,
                status: StatusPagamento.Pendente,
                ehUltimoPagamento: false,
                gerarApenasNoAsaas: !!entidade.gerarApenasNoAsaas,
            });
            toast.success('Pagamento criado com sucesso');
            setShowModalNovo(false);
            await reaplicarFiltrosAtuais();
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setIsSavingNovo(false);
        }
    };

    // A API exige pagamento_editar para baixar, cancelar, conciliar e alterar valor, e pagamento_excluir para excluir.
    const buscarPagamentosFiltrados = async (): Promise<Pagamento[]> => {
        // Usa o MESMO endpoint da listagem com os MESMOS filtros aplicados para garantir
        // que o export reflete exatamente o que está sendo mostrado (todas as páginas).
        // dataParaIso() usa horário LOCAL para evitar shift de fuso (toISOString é UTC).
        const dataParaIso = (d: Date) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        if (filtrosAplicados.id) {
            const r = await api.get(`/Pagamento/${filtrosAplicados.id}`);
            return r.data ? [r.data] : [];
        }
        if (filtrosAplicados.buscarPendentes) {
            const dataFimStr = filtrosAplicados.dataFim
                ? dataParaIso(filtrosAplicados.dataFim)
                : dataParaIso(new Date());
            const params = new URLSearchParams();
            params.append('page', '1');
            params.append('pageSize', '100000');
            const r = await api.get(`/PorEmpresaPorIntervaloPendente/${obterIdTenent(token)}/${dataFimStr}?${params.toString()}`);
            return r.data?.items ?? r.data ?? [];
        }
        const params = new URLSearchParams();
        params.append('idEmpresa', obterIdTenent(token));
        params.append('page', '1');
        params.append('pageSize', '100000');
        if (filtrosAplicados.idLocacao) params.append('idLocacao', filtrosAplicados.idLocacao);
        if (filtrosAplicados.dataInicio) params.append('dataInicial', dataParaIso(filtrosAplicados.dataInicio));
        if (filtrosAplicados.dataFim) params.append('dataFinal', dataParaIso(filtrosAplicados.dataFim));
        if (filtrosAplicados.status !== StatusPagamento.Todos) params.append('status', filtrosAplicados.status.toString());
        if (filtrosAplicados.tipoPeriodo === "pagamento") params.append('tipoPeriodo', 'pagamento');
        const slExport = statusLocacaoParaQuery(filtrosAplicados.statusLocacao);
        if (slExport) params.append('statusLocacao', slExport);
        const r = await api.get(`/Pagamento/Filtrar?${params.toString()}`);
        return r.data?.items ?? r.data ?? [];
    };

    const gerarDocumentosEmLote = async (tipo: 'fatura' | 'faturaUnificada' | 'recibo' | 'reciboUnificado', comPix = false) => {
        setCarregando(true);
        try {
            const lista = await buscarPagamentosFiltrados();
            const ehRecibo = tipo === 'recibo' || tipo === 'reciboUnificado';
            const selecao = ehRecibo ? pagamentosComRecibo(lista) : { pagos: lista, naoPagos: 0 };
            const itens = selecao.pagos.filter(p => !!p.id);
            if (itens.length === 0) {
                toast.info(ehRecibo
                    ? "Nenhum pagamento pago nos filtros atuais. O recibo só sai para pagamento recebido."
                    : "Nenhum pagamento nos filtros atuais.");
                return;
            }
            if (itens.length > LIMITE_DOCUMENTOS_EM_LOTE) {
                toast.info(`São ${itens.length} pagamentos. Refine os filtros para gerar até ${LIMITE_DOCUMENTOS_EM_LOTE} documentos por vez.`);
                return;
            }

            const [locacoes, empresa, logo, valores, pixes] = await Promise.all([
                carregarLocacoesPorId(idsDistintos(itens.map(p => p.idLocacao))),
                carregarEmpresaDoToken(token),
                carregarLogoDaEmpresa(token),
                carregarValoresDeCobranca(itens.map(p => p.id!)),
                comPix && !ehRecibo ? carregarPixDosPagamentos(itens) : Promise.resolve({} as Record<string, PixFatura>),
            ]);
            const nomeEmpresa = obterNomeEmpresa(token);

            if (tipo === 'fatura' || tipo === 'faturaUnificada') {
                const faturas = itens.map(p => faturaDePagamento(p, locacoes[p.idLocacao] ?? null, empresa, nomeEmpresa, valores[p.id!], new Date(), pixes[p.id!] ?? null));
                let lista = tipo === 'faturaUnificada' ? unificarPorCliente(faturas) : faturas;
                if (tipo === 'faturaUnificada' && comPix) {
                    lista = await Promise.all(lista.map(async f => comPixUnico(f, await carregarPixPorValor(valorEmAbertoDaFatura(f), f.idFilial))));
                }
                if (comPix && lista.every(f => !f.pixUnico && !f.parcelas.some(parcela => parcela.pix))) {
                    toast.info("Nenhuma cobrança em aberto com PIX disponível. Confira a chave PIX em Minha Conta ou a integração com o Asaas.");
                }
                abrirPdfNoVisualizador(gerarPdfFaturas(lista, logo), `faturas_${Date.now()}`);
            } else {
                const recibos = itens
                    .map(p => ({ pagamento: { ...p, valor: valores[p.id!] ?? p.valor }, locacao: locacoes[p.idLocacao] ? { ...locacoes[p.idLocacao], empresa: locacoes[p.idLocacao].empresa ?? empresa } : null }))
                    .filter(r => locacaoCompletaParaRecibo(r.locacao));
                if (recibos.length === 0) {
                    toast.info("Não foi possível carregar a locação dos pagamentos selecionados.");
                    return;
                }
                const pdf = tipo === 'reciboUnificado'
                    ? gerarPdfRecibosUnificados(agruparRecibosPorCliente(recibos), nomeEmpresa, logo)
                    : gerarPdfRecibos(recibos, nomeEmpresa, logo);
                abrirPdfNoVisualizador(pdf, `recibos_${Date.now()}`);
                if (recibos.length < itens.length) toast.info(`${itens.length - recibos.length} pagamento(s) sem locação completa ficaram fora.`);
            }
            if (selecao.naoPagos > 0) toast.info(`${selecao.naoPagos} pagamento(s) não recebido(s) ficaram fora do recibo.`);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const gerarFaturaDoPagamento = async (pagamento: Pagamento, comPix = false) => {
        if (!pagamento.id) return;
        setCarregando(true);
        try {
            const [locacoes, empresa, logo, valores, pixes] = await Promise.all([
                carregarLocacoesPorId(idsDistintos([pagamento.idLocacao])),
                carregarEmpresaDoToken(token),
                carregarLogoDaEmpresa(token),
                carregarValoresDeCobranca([pagamento.id]),
                comPix ? carregarPixDosPagamentos([pagamento]) : Promise.resolve({} as Record<string, PixFatura>),
            ]);
            const fatura = faturaDePagamento(pagamento, locacoes[pagamento.idLocacao] ?? null, empresa, obterNomeEmpresa(token), valores[pagamento.id], new Date(), pixes[pagamento.id] ?? null);
            if (comPix && !fatura.parcelas[0].pix) {
                toast.info(pagamentoEmAberto(pagamento)
                    ? "PIX indisponível para esta cobrança. Confira a chave PIX em Minha Conta ou a integração com o Asaas."
                    : "Pagamento já recebido: a fatura sai sem QR Code PIX.");
            }
            abrirPdfNoVisualizador(gerarPdfFaturas([fatura], logo), `fatura_${pagamento.id}`);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const podeEditarPagamento = usuarioTemPermissao(token, 'pagamento_editar');
    const podeExcluirPagamento = usuarioTemPermissao(token, 'pagamento_excluir');
    const permissoesDasAcoes: Record<string, boolean> = {
        'Baixar Pagamentos': podeEditarPagamento,
        'Cancelar Pagamentos': podeEditarPagamento,
        'Editar valor': podeEditarPagamento,
        'Confirmação rápida de Pagamento': podeEditarPagamento,
        'Confirmar/Editar Pagamento': podeEditarPagamento,
        'Cancelar Pagamento': podeEditarPagamento,
        'Corrigir Divergência': podeEditarPagamento,
        'Excluir Pagamento': podeExcluirPagamento,
        // Parcelar cria as parcelas novas e exclui a original.
        'Parcelar Pagamento': usuarioTemPermissao(token, 'pagamento_novo') && podeExcluirPagamento,
        'Ir para Nota Fiscal': podeVerNota,
        'Emitir Nota Fiscal': podeEmitirNota,
    };

    return (
        <>
            <LocaSmartLayout>
                <ListagemPagamento
                    buscar={triggerBuscar}
                    onBuscar={handleBuscar}
                    filtrosIniciais={filtrosAtuais}
                    colunas={colunas}
                    linhas={pagamentos}
                    carregando={carregando}
                    nomeEntidade="Pagamentos"
                    IconeEntidade={FaMoneyBill}
                    exibirAcoesDeCrud={false}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    opcoesBusca={opcoesBuscaPagamento}
                    placeholder="Buscar por Locação, Locatário ou Veículo"
                    dadosTotalizadores={totalizadoresBackend}
                    carregandoResumo={carregandoResumo}
                    exportOptions={exportOptions}
                    tituloExportacao="Pagamentos"
                    onExportarBuscarTudo={buscarPagamentosFiltrados}
                    onNovo={temPermissaoCriar ? () => { setShowModalNovo(true); setForcarAtualizacaoNovoPagamento(true); } : undefined}
                    acoesEmLote={ocultarAcoes([
                        {
                            icone: FaCheck,
                            titulo: "Baixar Pagamentos",
                            onClick: async (dI, dF, s, items) => handleAcaoEmLote('baixar', dI, dF, s, items)
                        },
                        {
                            icone: FaTimesCircle,
                            titulo: "Cancelar Pagamentos",
                            onClick: async (dI, dF, s, items) => handleAcaoEmLote('cancelar', dI, dF, s, items)
                        },
                        {
                            icone: FaEdit,
                            titulo: "Editar valor",
                            onClick: async (dI, dF, s, items) => handleEditarValorLote(dI, dF, s, items)
                        },
                        {
                            icone: FaFileInvoice,
                            titulo: "Gerar Faturas",
                            onClick: async () => gerarDocumentosEmLote('fatura'),
                            subAcoes: [
                                { icone: FaFileAlt, titulo: "Individual", onClick: async () => gerarDocumentosEmLote('fatura') },
                                { icone: FaQrcode, titulo: "Individual com QR Code PIX", onClick: async () => gerarDocumentosEmLote('fatura', true) },
                                { icone: FaLayerGroup, titulo: "Unificada", onClick: async () => gerarDocumentosEmLote('faturaUnificada') },
                                { icone: FaQrcode, titulo: "Unificada com QR Code PIX", onClick: async () => gerarDocumentosEmLote('faturaUnificada', true) },
                            ]
                        },
                        {
                            icone: FaFilePdf,
                            titulo: "Gerar Recibos",
                            onClick: async () => gerarDocumentosEmLote('recibo'),
                            subAcoes: [
                                { icone: FaFileAlt, titulo: "Individual", onClick: async () => gerarDocumentosEmLote('recibo') },
                                { icone: FaLayerGroup, titulo: "Unificado", onClick: async () => gerarDocumentosEmLote('reciboUnificado') },
                            ]
                        },
                        // Pagamento acompanha a unidade do veículo/locação (via cascade); não é
                        // atribuível diretamente em lote (F) — ação removida.
                    ], permissoesDasAcoes)}
                    acoesExtras={ocultarAcoes([
                        {
                            Icone: FaCheckDouble,
                            Texto: 'Confirmação rápida de Pagamento',
                            OnClick: async (e) => {
                                if (e.status == StatusPagamento.Pago) {
                                    toast.info("Esse pagamento já se encontra pago.");
                                } else {
                                    if (e.asaasPaymentId) {
                                        if (await confirm("Este pagamento é gerenciado pelo Asaas.\nAo confirmar, a fatura será marcada como recebida em dinheiro no Asaas. Deseja continuar?")) {
                                            handleConfirmarRapidoPagamento(e);
                                        }
                                        return;
                                    }
                                    handleConfirmarRapidoPagamento(e);
                                }
                            },
                            Cor: 'green',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaEdit,
                            Texto: 'Confirmar/Editar Pagamento',
                            OnClick: async (e) => {
                                // Valor devido (integral + juros) buscado por id: e.valor da grade não serve —
                                // para usuário comissionado a grade exibe a comissão da filial. O overlay de
                                // carregamento bloqueia um segundo clique e os estados do modal são definidos
                                // juntos APÓS o fetch, para uma resposta atrasada não misturar linhas.
                                setCarregando(true);
                                let valorCobranca: number;
                                try {
                                    valorCobranca = await obterValorCobranca(e.id);
                                } catch (error: any) {
                                    tratarErro(error);
                                    return;
                                } finally {
                                    setCarregando(false);
                                }
                                setPagamentoSelecionado(e);
                                setValorInicialModalConfirmacaoPagamento(valorCobranca);
                                // Para pagamento já pago, pré-preencher com a data de recebimento real (não o vencimento),
                                // para que a edição da "Data do Pagamento" parta da data correta.
                                const dataBaseModal = (e.status === StatusPagamento.Pago && e.dataPagamentoRealizado)
                                    ? e.dataPagamentoRealizado
                                    : e.dataPrevista;
                                // Recebimento não pode ser no futuro: o vencimento que ainda não chegou sugere hoje.
                                const hojeLocal = dateToInputValue(new Date());
                                const dataSugerida = dataBaseModal ? dataBaseModal.split("T")[0] : dataBaseModal;
                                setDataInicial(dataSugerida && dataSugerida > hojeLocal ? hojeLocal : dataSugerida);
                                setShowModalConfirmacaoPagamento(true);
                            },
                            Cor: 'green',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaWhatsapp,
                            Texto: 'Cobrar Pagamento',
                            OnClick: (e) => {
                                setPagamentoSelecionado(e);
                                handleCobrarPagamento(e);
                            },
                            Cor: 'green',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaTimesCircle,
                            Texto: 'Cancelar Pagamento',
                            OnClick: async (e) => {
                                if (e.status == StatusPagamento.Pendente || e.status == StatusPagamento.EmAtraso) {
                                    toast.info("Este pagamento está marcado como 'Pendente' ou 'Em Atraso', portanto, não é possível cancelá-lo no momento.");
                                    return;
                                }
                                if (e.asaasPaymentId) {
                                    if (await confirm("Este pagamento é gerenciado pelo Asaas.\nTem certeza que deseja cancelar? Essa ação não altera a fatura no Asaas.")) {
                                        handleCancelarPagamento(e.id);
                                    }
                                    return;
                                }
                                handleCancelarPagamento(e.id);
                            },
                            Cor: 'red',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaFlag,
                            Texto: 'Corrigir Divergência',
                            OnClick: async (e) => {
                                if (!e.asaasPaymentId) {
                                    toast.info("Este pagamento não está vinculado ao Asaas.");
                                    return;
                                }
                                if (await confirm("Será consultado o status real no Asaas e, se houver divergência, o pagamento será corrigido. Deseja continuar?")) {
                                    handleConciliarComAsaas(e.id);
                                }
                            },
                            Cor: 'red',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaTrash,
                            Texto: 'Excluir Pagamento',
                            OnClick: async (e) => {
                                if (e.asaasPaymentId) {
                                    if (!await confirm("Este pagamento é gerenciado pelo Asaas.\nA cobrança também será removida no Asaas. Deseja continuar?")) {
                                        return;
                                    }
                                }
                                setPagamentoSelecionado(e);
                                setMessageModalConfirmarExclusao(['Deseja realmente excluir o Pagamento abaixo?', `Valor: R$ ${e.valor}`, `Pagador: ${e.locacao.locatario.nome}`]);
                                setShowModalConfirmarExclusao(true);
                            },
                            Cor: 'gray',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaLayerGroup,
                            Texto: 'Parcelar Pagamento',
                            OnClick: async (e: any) => {
                                if (e.status === StatusPagamento.Pago) {
                                    toast.warning("Não é possível parcelar um pagamento que já foi pago ou cancelado.");
                                    return;
                                }
                                // Fluxo de ESCRITA: o parcelamento gera novas parcelas e exclui a original,
                                // então o total a parcelar precisa ser o valor devido buscado por id — o
                                // e.valor da grade, para usuário comissionado, é a comissão da filial.
                                setCarregando(true);
                                let valorCobranca: number;
                                try {
                                    valorCobranca = await obterValorCobranca(e.id);
                                } catch (error: any) {
                                    tratarErro(error);
                                    return;
                                } finally {
                                    setCarregando(false);
                                }
                                setPagamentoSelecionado({ ...e, valor: valorCobranca });
                                setShowModalParcelamento(true);
                            },
                            Cor: '#1f467e',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaFilePdf,
                            Texto: 'Gerar Recibo',
                            OnClick: async (e) => {
                                if (e.status != StatusPagamento.Pago) {
                                    toast.error("Não é possível gerar recibo de um pagamento não recebido.")
                                    return;
                                }
                                // Recibo é documento do LOCATÁRIO: precisa do valor realmente pago, buscado
                                // por id — o e.valor da grade, para usuário comissionado, é a comissão.
                                setCarregando(true);
                                let valorCobranca: number;
                                try {
                                    valorCobranca = await obterValorCobranca(e.id);
                                } catch (error: any) {
                                    tratarErro(error);
                                    return;
                                } finally {
                                    setCarregando(false);
                                }
                                setPagamentoParaRecibo({ ...e, valor: valorCobranca });
                                setTriggerRecibo(prev => prev + 1);
                            },
                            Cor: 'gray',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaFileInvoice,
                            Texto: 'Gerar Fatura',
                            OnClick: async (e) => gerarFaturaDoPagamento(e),
                            Cor: 'gray',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaQrcode,
                            Texto: 'Gerar Fatura com QR Code PIX',
                            OnClick: async (e) => gerarFaturaDoPagamento(e, true),
                            Cor: 'gray',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaFileInvoiceDollar,
                            Texto: 'Ir para Nota Fiscal',
                            OnClick: (e) => {
                                window.location.href = `/notas-fiscais?idPagamento=${e.id}`;
                            },
                            Cor: 'gray',
                            Tamanho: 'small',
                            Condicao(entidade) {
                                return emissaoLiberada && entidade.nfService.id != '00000000-0000-0000-0000-000000000000' || false
                            },
                            TooltipDisabled(entidade) {
                                return "Nota Fiscal não emitida ainda."
                            },
                        },
                        {
                            Icone: FaLink,
                            Texto: 'Obter Link da Fatura',
                            OnClick: async (e) => {
                                await handleObterFatura(e);
                            },
                            Condicao(entidade) {
                                return entidade.asaasPaymentId;
                            },
                            TooltipDisabled(entidade) {
                                return "Pagamento não vinculado ao Asaas"
                            },
                            Cor: 'gray',
                            Tamanho: 'small'
                        },
                        {
                            Icone: FaFileInvoice,
                            Texto: 'Emitir Nota Fiscal',
                            OnClick: async (e) => {
                                await handleEmitirNota(e);
                            },
                            Condicao(entidade) {
                                return emissaoLiberada && entidade.nfService.id == '00000000-0000-0000-0000-000000000000' || false
                            },
                            TooltipDisabled(entidade) {
                                return emissaoLiberada ? "" : "A emissão de NFS-e ainda não está liberada para a sua Empresa."
                            },
                            Cor: 'gray',
                            Tamanho: 'small'
                        },
                    ], permissoesDasAcoes)}
                />

                <ModalConfirmacaoLote
                    open={showModalLote}
                    onClose={() => setShowModalLote(false)}
                    onConfirm={async () => {
                        setShowModalLote(false);
                        if (acaoLote === 'baixar') {
                            await handleBaixarTodos(filtrosAtuais);
                        } else {
                            await handleCancelarTodos(filtrosAtuais);
                        }
                    }}
                    dados={dadosLote}
                    titulo={acaoLote === 'baixar' ? "Confirmar Baixa em Lote" : "Confirmar Cancelamento em Lote"}
                    tipoAcao={acaoLote}
                    filtros={filtrosAtuais}
                    tela="pagamentos"
                />

                <ModalAjusteValorLote
                    open={showModalEditarValor}
                    onClose={() => setShowModalEditarValor(false)}
                    onConfirm={handleConfirmarEditarValor}
                    dados={dadosEditarValor}
                    itens={itensEditarValor}
                    filtros={{
                        dataInicio: filtrosEditarValor?.dataInicio ?? null,
                        dataFim: filtrosEditarValor?.dataFim ?? null,
                        status: filtrosEditarValor?.status ?? StatusPagamento.Todos,
                        idLocacao: filtrosEditarValor?.idLocacao ?? "",
                    }}
                    carregando={carregandoEditarValor}
                    mostrarOpcaoBaixa={true}
                />

                <ModalAlerta
                    message={messageModalSimNao}
                    show={showModalSimNao}
                    ehDeSimNao={true}
                    onHide={() => { setShowModalSimNao(false) }}
                    onSim={handleSimModalSimNao}
                />

                <ModalAlerta
                    message={messageModalConfirmarExclusao}
                    show={showModalConfirmarExclusao}
                    ehDeSimNao={true}
                    onHide={() => { setShowModalConfirmarExclusao(false) }}
                    onSim={() => handleExcluirPagamento(pagamentoSelecionado.id)}
                />

                <ModalConfirmacaoPagamento
                    onClose={() => { setShowModalConfirmacaoPagamento(false) }}
                    onConfirm={async (dados) => {
                        try {
                            await handleConfirmarPagamento(dados);
                        } catch (error) {
                            toast.error("Ocorreu um erro ao confirmar o pagamento");
                        }
                    }}
                    onSubmitting={(submitting) => { }}
                    show={showModalConfirmacaoPagamento}
                    valorInicial={valorInicialModalConfirmacaoPagamento}
                    motivoPagamento={pagamentoSelecionado?.descricao || motivoPagamento}
                    dataInicial={dataInicial}
                    integradoAsaas={!!pagamentoSelecionado?.asaasPaymentId}
                    statusPagamento={pagamentoSelecionado?.status}
                    idBancoInicial={pagamentoSelecionado?.idBanco ?? null}
                />

                <ModalParcelamento
                    show={showModalParcelamento}
                    onClose={() => {
                        setShowModalParcelamento(false);
                    }}
                    pagamento={pagamentoSelecionado?.id ? {
                        id: pagamentoSelecionado.id,
                        idLocacao: pagamentoSelecionado.idLocacao,
                        idEmpresa: pagamentoSelecionado.idEmpresa,
                        valor: pagamentoSelecionado.valor,
                        descricao: pagamentoSelecionado.descricao,
                        dataPrevista: pagamentoSelecionado.dataPrevista,
                        asaasPaymentId: pagamentoSelecionado.asaasPaymentId,
                        periodicidadeLocacao: pagamentoSelecionado.locacao?.periodicidadePagamento,
                    } : null}
                    onConfirm={handleParcelar}
                    integradoAsaas={!!pagamentoSelecionado?.asaasPaymentId}
                />

                <ModalForm
                    modo={TipoFormulario.tpCadastro}
                    tamanho="lg"
                    campos={camposPagamentos}
                    onSave={onSavePagamentos}
                    show={exibirFormModalPagamentos}
                    carregando={isSavingPagamentos}
                    onHide={() => {
                        setExibirFormModalPagamentos(false);
                    }}
                    onCancel={() => {
                        setExibirFormModalPagamentos(false);
                    }}
                    isSaving={isSavingPagamentos}
                    onShow={atualizarCamposPagamentos}
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeParaAtualizarPagamentos,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModalPagamentos
                        }
                    }
                    titulo="Prolongar Locação"
                    tituloBotaoOk="Gerar"
                    apiConfig={
                        {
                            endpoint: 'pagamentos',
                            idTenentCampo: 'idEmpresa',
                            requisicaoBemSucedida: () => { },
                            tratarErro: tratarErro,
                        }
                    }
                />

                <ReciboPagamento
                    pagamento={pagamentoParaRecibo!}
                    trigger={triggerRecibo}
                />

                <ModalEmitirNota
                    show={showModalEmitirNota}
                    onHide={() => setShowModalEmitirNota(false)}
                    onEmitir={(idServico) => emitirNota(dadosParaEmitirNota, idServico)}
                    carregando={carregando}
                />

                <ModalForm
                    modo={TipoFormulario.tpCadastro}
                    tamanho="lg"
                    campos={camposNovoPagamento}
                    onSave={onSaveNovoPagamento}
                    show={showModalNovo}
                    carregando={isSavingNovo}
                    onHide={() => { setShowModalNovo(false); setForcarAtualizacaoNovoPagamento(false); }}
                    onCancel={() => { setShowModalNovo(false); setForcarAtualizacaoNovoPagamento(false); }}
                    isSaving={isSavingNovo}
                    titulo="Novo Pagamento"
                    tituloBotaoOk="Criar"
                    apiConfig={{ endpoint: '', idTenentCampo: 'idEmpresa', requisicaoBemSucedida: () => {}, tratarErro: () => {} }}
                    atualizacaoEntidade={{
                        entidadeUsadaParaAtualizacao: { gerarApenasNoAsaas: contaIntegradaAsaas },
                        forcarAtualizacao: forcarAtualizacaoNovoPagamento
                    }}
                />
            </LocaSmartLayout>
        </>
    );
}

export default PagamentoListagem;